import restApiConnection from '@/services/api/providers/Connection'
import RestApiBase from '@/services/models/RestApiBase'
import DepartmentType from '@/types/department'
import UserSession from '@/services/models/UserSession'
import { AxiosResponse } from 'axios'
import { CacheAxiosResponse } from 'axios-cache-interceptor'
import { CACHE_TTL_DEFAULT } from '@/config'

export default class Department extends RestApiBase {
  public static async get(
    operationOfficeIds?: number[]
  ): Promise<AxiosResponse<DepartmentType[]>> {
    return this.sync('GetDepartments', this.getOwn, operationOfficeIds)
  }

  public static getOwn = async (
    operationOfficeIds?: number[]
  ): Promise<CacheAxiosResponse<DepartmentType[]> | undefined> => {
    const config = {
      cache: {
        ttl: CACHE_TTL_DEFAULT,
      },
      params: {
        user_session_id: UserSession.getStoredUserId(),
        operation_office_ids: operationOfficeIds?.join(','),
      },
    }
    return await restApiConnection
      .get('/departments', config)
      .catch(async (error) => {
        console.error('API Call Failed on Departments. Error:', error)
        throw error
      })
  }
}
